import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

// ✅ Attach AutoTable plugin to jsPDF
import ReportsFilters from "./ReportsFilters.js";

import { getReportsData } from "../../../APIS";

const Reports = () => {
  const [totalData, setTotalData] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedType, setSelectedType] = useState("All");
  const itemsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(0);
  const storedUser = sessionStorage.getItem("userDetails");
  const [filterCategory, setFilterCategory] = useState("All");
  const [filterType, setFilterType] = useState("All");
  const [filterDate, setFilterDate] = useState("");
  const [filterSubmittedBy, setFilterSubmittedBy] = useState("All");

  let token = null;
  if (storedUser) {
    const userDetails = JSON.parse(storedUser);
    token = userDetails?.token;
  }
  useEffect(() => {
    const fetchReports = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getReportsData(token);
        setTotalData(data);
        if (!data?.forms || !Array.isArray(data.forms)) {
          throw new Error("Invalid data format");
        }
        const formatted = data.forms.map((r) => ({
          _id: r._id,
          id: r._id.slice(-5),
          category: r.inspection_cat?.name || "--",
          date: new Date(r.createdAt).toISOString().split("T")[0],
          type: r.form_cat?.name?.split("-")[1] ?? r.form_cat?.name ?? "--",
          submittedBy: r.user_id?.name || "--",
        }));

        setReportData(formatted);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch reports.");
      } finally {
        setLoading(false);
      }
    };
    fetchReports();
  }, []);

  const waitForImagesToLoad = (container) => {
    const imgs = container.querySelectorAll("img");
    return Promise.all(
      Array.from(imgs).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else img.onload = img.onerror = resolve;
          })
      )
    );
  };

  const getAnswerSymbol = (answer) => {
    if (!answer) return "";
    const lower = answer.toLowerCase();
    if (lower === "yes") return "✔";
    if (lower === "no") return "✖";
    if (lower === "high") return "⚠";
    return answer;
  };
  // Helper to convert image URLs to base64

  // Wait for all images
  const waitForImages = (el) =>
    Promise.all(
      [...el.querySelectorAll("img")].map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else img.onload = resolve;
          })
      )
    );

  // Utility to convert URL to Base64
  const toBase64 = async (url) => {
    try {
      const res = await fetch(url, { mode: "cors" });
      const blob = await res.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.warn("Image load failed:", url);
      return null;
    }
  };

  // const generatePdfDoc = async (_id, totalData) => {
  //   if (!totalData) return;

  //   const raw = totalData.forms.find((f) => f._id === _id);
  //   if (!raw) return;

  //   const pdf = new jsPDF("p", "mm", "a4");
  //   const pageWidth = pdf.internal.pageSize.getWidth();

  //   pdf.setFontSize(18);
  //   pdf.text("Mechanical Daily Inspection Form", pageWidth / 2, 15, {
  //     align: "center",
  //   });
  //   pdf.setFontSize(12);
  //   pdf.text(
  //     `Date: ${new Date(raw.createdAt).toLocaleDateString()}`,
  //     pageWidth / 2,
  //     22,
  //     { align: "center" }
  //   );
  //   pdf.line(10, 28, pageWidth - 10, 28);

  //   // Preload all images into Base64
  //   const tableRows = await Promise.all(
  //     raw.form[0].items.map(async (item) => {
  //       const imgBase = item.img?.length ? await toBase64(item.img[0]) : null;
  //       const mapBase = item.latlng
  //         ? await toBase64(
  //             "https://cdn-icons-png.flaticon.com/512/684/684908.png"
  //           )
  //         : null;

  //       return {
  //         question: item.question || "",
  //         answer:
  //           item.answer?.toLowerCase() === "yes"
  //             ? "✔"
  //             : item.answer?.toLowerCase() === "no"
  //             ? "✖"
  //             : item.answer || "",
  //         remarks: item.remarks || "",
  //         imgBase,
  //         mapBase,
  //         latlng: item.latlng,
  //       };
  //     })
  //   );

  //   autoTable(pdf, {
  //     startY: 35,
  //     head: [["Items", "Inspection", "Remarks", "Map", "Image"]],
  //     body: tableRows.map((row) => [
  //       row.question,
  //       row.answer,
  //       row.remarks,
  //       row.mapBase ? "MAP" : "",
  //       row.imgBase ? "IMAGE" : "",
  //     ]),
  //     didDrawCell: (data) => {
  //       const row = tableRows[data.row.index];

  //       // Draw Map Icon
  //       if (data.column.index === 3 && row.mapBase) {
  //         pdf.addImage(
  //           row.mapBase,
  //           "PNG",
  //           data.cell.x + 6,
  //           data.cell.y + 2,
  //           10,
  //           10
  //         );
  //         pdf.link(
  //           data.cell.x,
  //           data.cell.y,
  //           data.cell.width,
  //           data.cell.height,
  //           { url: `https://www.google.com/maps?q=${row.latlng}` }
  //         );
  //       }

  //       // Draw Item Image
  //       if (data.column.index === 4 && row.imgBase) {
  //         pdf.addImage(
  //           row.imgBase,
  //           "JPEG",
  //           data.cell.x + 3,
  //           data.cell.y + 2,
  //           23,
  //           23
  //         );
  //       }
  //     },
  //     styles: { fontSize: 10, cellPadding: 3, valign: "middle" },
  //     headStyles: {
  //       fillColor: [71, 178, 145],
  //       textColor: 255,
  //       halign: "center",
  //     },
  //     columnStyles: {
  //       0: { cellWidth: 50 },
  //       1: { cellWidth: 25, halign: "center" },
  //       2: { cellWidth: 50 },
  //       3: { cellWidth: 25, halign: "center" },
  //       4: { cellWidth: 30, halign: "center" },
  //     },
  //   });

  //   pdf.output("dataurlnewwindow");
  // };

  const generatePdfDoc = async (_id) => {
    if (!totalData) return {};
    const raw = totalData.forms.find((f) => f._id === _id);
    if (!raw) return {};

    // 1️⃣ Create hidden HTML container
    const container = document.createElement("div");
    container.style.width = "800px";
    container.style.padding = "20px";
    container.style.backgroundColor = "#fff";
    container.style.fontFamily = "Arial, sans-serif";
    const dateStr = new Date(raw.createdAt).toLocaleDateString();
    container.innerHTML = `
      <h1 style="text-align:center; color:#47B291;">Mechanical Daily Inspection Form</h1>
      <p style="text-align:center;">Date: ${dateStr}</p>
      <hr/>
    `;

    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";

    // 2️⃣ Build table rows
    const rowsHTML = await Promise.all(
      raw.form[0].items.map(async (item) => {
        const latIconURL = "https://cdn-icons-png.flaticon.com/512/684/684908.png";
        const mapBase64 = await toBase64(latIconURL);
        const latIcon = item.latlng
          ? `<img src="${mapBase64}" style="width:20px;height:20px; display:block; margin:auto;" data-latlng="${item.latlng}"/>`
          : "";

        let imagesHTML = "";
        if (item.img && item.img.length) {
          const base64Images = await Promise.all(item.img.map(toBase64));
          imagesHTML = base64Images
            .filter(Boolean)
            .map(
              (b64) =>
                `<img src="${b64}" style="width:180px; max-height:150px; display:block; margin:2px auto;"/>`
            )
            .join("");
        }

        const answerText = getAnswerSymbol(item.answer);

        return `
          <tr>
            <td style="border:1px solid #000; padding:5px; max-width:120px;">${item.question || ""}</td>
            <td style="border:1px solid #000; padding:5px; text-align:center; width:80px;">${answerText}</td>
            <td style="border:1px solid #000; padding:5px; width:120px;">${item.remarks || ""}</td>
            <td style="border:1px solid #000; padding:5px; text-align:center; width:40px;">${latIcon}</td>
            <td style="border:1px solid #000; padding:5px; text-align:center; width:160px;">${imagesHTML}</td>
          </tr>
        `;
      })
    );

    table.innerHTML = `
      <thead>
        <tr>
          <th style="border:1px solid #000; padding:5px; width:120px;">Items</th>
          <th style="border:1px solid #000; padding:5px; width:80px;">Inspection</th>
          <th style="border:1px solid #000; padding:5px; width:120px;">Remarks</th>
          <th style="border:1px solid #000; padding:5px; width:40px;">Map</th>
          <th style="border:1px solid #000; padding:5px; width:160px;">Image</th>
        </tr>
      </thead>
      <tbody>${rowsHTML.join("")}</tbody>
    `;

    container.appendChild(table);
    container.style.position = "fixed";
    container.style.left = "-9999px";
    document.body.appendChild(container);

    // 3️⃣ Wait for images to load
    await waitForImagesToLoad(container);

    // 4️⃣ Convert HTML → canvas → image
    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 5;

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pageWidth - margin * 2;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    let heightLeft = pdfHeight;
    let position = margin;

    // 5️⃣ Add first page
    pdf.addImage(imgData, "JPEG", margin, position, pdfWidth, pdfHeight);
    heightLeft -= pageHeight - margin * 2;

    // 6️⃣ Add more pages if needed
    while (heightLeft > 0) {
      pdf.addPage();
      position = -(pdfHeight - (pageHeight - margin * 2));
      pdf.addImage(imgData, "JPEG", margin, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight - margin * 2;
    }

    // 7️⃣ Add clickable Map links
    raw.form[0].items.forEach((item, index) => {
      if (item.latlng) {
        const x = 5 + ((pageWidth - 10) * 3) / 5;
        const rowHeight = 40;
        const y = 25 + index * rowHeight;
        pdf.link(x, y, 20, 20, {
          url: `https://www.google.com/maps?q=${item.latlng}`,
        });
      }
    });

    pdf.output("dataurlnewwindow");
    document.body.removeChild(container);
  };

  // const toBase64 = async (url) => {
  //   try {
  //     const res = await fetch(url, { mode: "cors" }); // CORS safe
  //     if (!res.ok) throw new Error("Image fetch failed");
  //     const blob = await res.blob();
  //     return new Promise((resolve, reject) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => resolve(reader.result);
  //       reader.onerror = reject;
  //       reader.readAsDataURL(blob);
  //     });
  //   } catch (err) {
  //     console.warn("Failed to load image:", url, err);
  //     return null; // fallback
  //   }
  // };

  // const generatePdfDoc = async (_id) => {
  //   if (!totalData) return {};
  //   const raw = totalData.forms.find((f) => f._id === _id);
  //   console.log(raw);
  //   if (!raw) return {};

  //   const doc = new jsPDF("portrait", "mm", "a4");
  //   const W = doc.internal.pageSize.getWidth();
  //   const H = doc.internal.pageSize.getHeight();
  //   const margin = 5;
  //   const bottomMargin = 5;
  //   const lineHeight = 7;
  //   const cellPadding = 3;
  //   const sectionPadding = 0;

  //   const dateStr = new Date(raw.createdAt).toLocaleDateString();
  //   const today = new Date();
  //   const fileDate = today.toISOString().split("T")[0];

  //   const formX = margin;
  //   const formWidth = W - margin * 2;
  //   const formPadding = 5;
  //   const contentX = formX + formPadding + sectionPadding;
  //   const contentWidth = formWidth - 2 * formPadding - 2 * sectionPadding;

  //   // 5 columns: Items / Inspection / Remarks / Location / Image
  //   const colW = [
  //     contentWidth * 0.22, // Items
  //     contentWidth * 0.15, // Inspection
  //     contentWidth * 0.22, // Remarks
  //     contentWidth * 0.2, // Location
  //     contentWidth * 0.21, // Image (width increased)
  //   ];

  //   let y = 40;

  //   const addNewPage = () => {
  //     doc.addPage();
  //     y = margin;
  //     // doc.setFillColor(255, 255, 255);
  //     // doc.rect(0, 0, W, H, "F");
  //   };

  //   // doc.setFillColor(255, 255, 255);
  //   // doc.rect(0, 0, W, H, "F");

  //   doc.setFont("helvetica", "bold").setFontSize(20).setTextColor("#47B291");
  //   doc.text("Mechanical Daily Inspection Form", W / 2, 20, {
  //     align: "center",
  //   });
  //   doc.setFontSize(12).setTextColor("#000");
  //   doc.text(`Date: ${dateStr}`, W / 2, 28, { align: "center" });

  //   // Convert images to base64
  //   const processedItems = await Promise.all(
  //     raw.form[0].items.map(async (it) => ({
  //       ...it,
  //       img:
  //         it.img && it.img.length
  //           ? await Promise.all(it.img.map((url) => toBase64(url)))
  //           : [],
  //     }))
  //   );
  //   console.log("Processed items with base64:", processedItems);

  //   const renderSection = async (title, items, isMaterial = false) => {
  //     let sectionTopY = y;
  //     y += sectionPadding;

  //     const drawHeader = () => {
  //       doc.setFont("helvetica", "bold").setFontSize(12).setTextColor("#000");
  //       doc.text(title, W / 2, (y += 8), { align: "center" });
  //       doc.setDrawColor(220);
  //       doc.line(contentX, (y += 4), contentX + contentWidth, y);
  //       y += 4;

  //       doc.setFontSize(10).setFont("helvetica", "bold");
  //       const headers = isMaterial
  //         ? ["Material", "Issued", "Used"]
  //         : ["Items", "Inspection", "Remarks", "Location", "Image"];

  //       let headerX = contentX;
  //       headers.forEach((h, i) => {
  //         doc.text(h, headerX + colW[i] / 2, y + 4, { align: "center" });
  //         headerX += colW[i];
  //       });
  //       y += 8;
  //       doc.setFont("helvetica", "normal").setFontSize(10);
  //       doc.setDrawColor(200);
  //     };

  //     drawHeader();

  //     const imageHeight = 20;
  //     const imageWidth = 20;

  //     for (const it of items) {
  //       const leftText = doc.splitTextToSize(
  //         isMaterial ? it.material?.name || "" : it.question || "",
  //         colW[0] - 2 * cellPadding
  //       );
  //       const centerText = isMaterial ? it.issued || "" : it.answer || "";
  //       const remarksText = doc.splitTextToSize(
  //         isMaterial ? it.used || "" : it.remarks || "",
  //         colW[2] - 2 * cellPadding
  //       );
  //       const latlng = it.latlng || "";
  //       const googleLink = latlng
  //         ? `https://www.google.com/maps?q=${latlng}`
  //         : "";
  //       const imgArray = Array.isArray(it.img) ? it.img : [];

  //       let lineCount = Math.max(leftText.length, remarksText.length, 1);
  //       let rowHeight = lineCount * lineHeight + 2 * cellPadding;
  //       if (imgArray.length > 0) rowHeight += imageHeight + 4;

  //       if (y + rowHeight + bottomMargin + sectionPadding > H) {
  //         const sectionHeight = y - sectionTopY + sectionPadding;
  //         // doc.roundedRect(
  //         //   formX,
  //         //   sectionTopY,
  //         //   formWidth,
  //         //   sectionHeight,
  //         //   3,
  //         //   3,
  //         //   "D"
  //         // );
  //         addNewPage();
  //         sectionTopY = y;
  //         y += sectionPadding;
  //         drawHeader();
  //       }

  //       let cellX = contentX;

  //       // Items
  //       doc.rect(cellX, y, colW[0], rowHeight);
  //       doc.text(leftText, cellX + colW[0] / 2, y + lineHeight, {
  //         align: "center",
  //       });
  //       cellX += colW[0];

  //       // Inspection
  //       doc.rect(cellX, y, colW[1], rowHeight);
  //       if (!isMaterial && centerText?.toLowerCase() === "yes") {
  //         const tickCenterX = cellX + colW[1] / 2;
  //         const tickCenterY = y + rowHeight / 2;
  //         doc.setDrawColor(0);
  //         doc.setLineWidth(0.5);
  //         doc.line(tickCenterX - 2, tickCenterY, tickCenterX, tickCenterY + 2);
  //         doc.line(
  //           tickCenterX,
  //           tickCenterY + 2,
  //           tickCenterX + 3,
  //           tickCenterY - 2
  //         );
  //         doc.setDrawColor(200);
  //         doc.setLineWidth(0.1);
  //       } else if (centerText) {
  //         doc.text(
  //           centerText.toString(),
  //           cellX + colW[1] / 2,
  //           y + rowHeight / 2 + 2,
  //           { align: "center" }
  //         );
  //       }
  //       cellX += colW[1];

  //       // Remarks
  //       doc.rect(cellX, y, colW[2], rowHeight);
  //       doc.text(remarksText, cellX + colW[2] / 2, y + lineHeight, {
  //         align: "center",
  //       });
  //       cellX += colW[2];

  //       // Location
  //       doc.rect(cellX, y, colW[3], rowHeight);
  //       if (latlng) {
  //         doc.setTextColor(0, 0, 255);
  //         doc.textWithLink(latlng, cellX + colW[3] / 2, y + rowHeight / 2 + 2, {
  //           url: googleLink,
  //           align: "center",
  //         });
  //         doc.setTextColor("#000");
  //       }
  //       cellX += colW[3];
  //       doc.rect(cellX, y, colW[4], rowHeight);

  //       for (let i = 0; i < imgArray.length && i < 2; i++) {
  //         const img = imgArray[i];
  //         if (!img) {
  //           console.warn("Skipping invalid image at index", i);
  //           continue;
  //         }

  //         // Ensure it's base64 string starting with data:image/jpeg;base64,
  //         if (!img.startsWith("data:image")) {
  //           console.warn("Invalid base64 image format", img);
  //           continue;
  //         }

  //         try {
  //           const imgY = y + lineHeight + i * (imageHeight + 2);
  //           const imgX = cellX + (colW[4] - imageWidth) / 2;
  //           const format = img.startsWith("data:image/png") ? "PNG" : "JPEG";
  //           doc.addImage(img, format, imgX, imgY, imageWidth, imageHeight);
  //         } catch (err) {
  //           console.error("Image error:", err);
  //         }
  //       }

  //       y += rowHeight;
  //     }

  //     y += sectionPadding;
  //     const sectionHeight = y - sectionTopY;
  //     // doc.roundedRect(formX, sectionTopY, formWidth, sectionHeight, 3, 3, "D");
  //     y += 10;
  //   };

  //   await renderSection(
  //     `Inspected By: ${raw.user_id.name}` || "Mechanical Report",
  //     processedItems
  //   );

  //   const materialItems = Array.isArray(raw.materials)
  //     ? raw.materials.map((m) => ({
  //         material: m.material,
  //         issued: m.issued,
  //         used: m.used,
  //       }))
  //     : [];

  //   if (materialItems.length > 0) {
  //     if (y + 40 > H) addNewPage();
  //     await renderSection("General Guidelines", materialItems, true);
  //   }

  //   if (y + 20 > H) addNewPage();
  //   doc.setFontSize(10).setTextColor("#999");
  //   // Left-aligned footer
  //   doc.text("Generated by Inspection App Dashboard", margin, H - 10, {
  //     align: "left",
  //   });

  //   // Right-aligned footer
  //   doc.text(`© ${today.getFullYear()}`, W - margin, H - 10, {
  //     align: "right",
  //   });

  //   // 🔹 Open PDF in new tab
  //   doc.output("dataurlnewwindow");

  //   return { doc, fileDate };
  // };

  // Apply filters

  const filteredReports = reportData.filter((r) => {
    const matchesCategory =
      filterCategory === "All" || r.category === filterCategory;
    const matchesType = filterType === "All" || r.type === filterType;
    const matchesSubmittedBy =
      filterSubmittedBy === "All" || r.submittedBy === filterSubmittedBy;
    const matchesDate = !filterDate || r.date === filterDate;

    return matchesCategory && matchesType && matchesSubmittedBy && matchesDate;
  });

  // Recalculate pagination after filtering
  const totalPages = Math.ceil(filteredReports.length / itemsPerPage);
  const currentItems = filteredReports.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const uniqueTypes = ["All", ...new Set(reportData.map((r) => r.type))];
  const uniqueCategories = [
    "All",
    ...new Set(reportData.map((r) => r.category)),
  ];
  const uniqueSubmittedBy = [
    "All",
    ...new Set(reportData.map((r) => r.submittedBy)),
  ];

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">Reports</h4>
          <ReportsFilters
            filterCategory={filterCategory}
            filterType={filterType}
            filterDate={filterDate}
            filterSubmittedBy={filterSubmittedBy}
            uniqueCategories={uniqueCategories}
            uniqueTypes={uniqueTypes}
            uniqueSubmittedBy={uniqueSubmittedBy}
            setFilterCategory={setFilterCategory}
            setFilterType={setFilterType}
            setFilterDate={setFilterDate}
            setFilterSubmittedBy={setFilterSubmittedBy}
            resetFilters={() => {
              setFilterCategory("All");
              setFilterType("All");
              setFilterDate("");
              setFilterSubmittedBy("All");
            }}
          />
        </div>
        <div className="card-body">
          {loading && <p>Loading...</p>}
          {error && <p className="text-danger">{error}</p>}
          {!loading && !error && (
            <>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Category</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Submitted By</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((r) => (
                      <tr key={r._id}>
                        <td>{r.id}</td>
                        <td>{r.category}</td>
                        <td>{r.type}</td>
                        <td>{r.date}</td>
                        <td>{r.submittedBy}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle variant="link">
                              •••
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="end">
                              <Dropdown.Item
                                onClick={async () => {
                                  const pdf = await generatePdfDoc(
                                    r._id,
                                    totalData
                                  );
                                  //if (pdf) pdf.output("dataurlnewwindow");
                                }}
                              >
                                View Report
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={async () => {
                                  const { pdf } = await generatePdfDoc(r._id);
                                  if (pdf) pdf.save(`Report-${r.id}.pdf`);
                                }}
                              >
                                Download Report
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <div>
                  Showing {currentPage * itemsPerPage + 1} to{" "}
                  {Math.min(
                    (currentPage + 1) * itemsPerPage,
                    filteredReports.length
                  )}{" "}
                  of {filteredReports.length} entries
                </div>
                <div>
                  <button
                    className={`btn btn-sm btn-outline-primary me-2 ${
                      currentPage === 0 ? "disabled" : ""
                    }`}
                    onClick={() =>
                      currentPage > 0 && setCurrentPage(currentPage - 1)
                    }
                  >
                    Prev
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      key={i}
                      className={`btn btn-sm border me-2 ${
                        currentPage === i ? "btn-primary  text-white" : ""
                      }`}
                      onClick={() => setCurrentPage(i)}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button
                    className={`btn btn-sm btn-outline-primary  ${
                      currentPage === totalPages - 1 ? "disabled" : ""
                    }`}
                    onClick={() =>
                      currentPage + 1 < totalPages &&
                      setCurrentPage(currentPage + 1)
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;
